// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"153":"68e2e7ef","229":"7d8363be","662":"eb2df193","712":"70ba4d57","811":"ef936bac"}[chunkId] + ".chunk.css";
};